import {FeatureFlagService} from './feature-flag.service';
import {ConfigLoaderService} from './config-loader.service';

export function PreloadFactory(configService: ConfigLoaderService, featureFlagService: FeatureFlagService) {
  return () => configService.loadConfig().then(() => featureFlagService.load());
}
